import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'

import { BsCaretLeft } from 'react-icons/bs'

import { GetPlayer } from '../../hoc/Layout/Layout'

const Browse = ({items, follow}) => {
    const history = useHistory()
    const [main, setMain] = useState(0)
    
    const { pid, setPid, setTracks } = GetPlayer()

    const renderItems = () => {
        return items.map((item, i) => (
            <div key={i} onClick={() => setMain(i)} className={`browse__image-item ${i === main ? 'browse__image-item--main' : null}`} style={{backgroundImage: `url('${item.images[0].url}')`}}></div>
        ))
    }

    const calcTranslation = (index, w, pad) => {
        return ((w * index) + ((index > 0 ? index * pad : 0)))
    }

    useEffect(()=>{
        if(!pid){
            setPid(items[main].first_track);setTracks(items[main].tracks.map(track => track.track.id))
        }
    }, [])
    return (
        <div className="browse">
                 <div className="browse__content-text">
                        <div className="browse__bg" 
                         style={{backgroundImage: `linear-gradient(rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)), url('${items[main].images[0].url}')`}}
                        ></div>

                        <div className="browse__text-content">
                            <h2>{items[main].name}</h2>
                            <p>{items[main].description}</p>
                            <div>
                                <button className="play" onClick={() => {setPid(items[main].first_track);setTracks(items[main].tracks.map(track => track.track.id))}}>Play</button>
                                <button className="add" onClick={() => follow(items[main].id)}>Follow</button>
                                <button className="add" onClick={()=>history.push(`/playlist/${items[main].id}`)}>Tracks</button>
                            </div>
                        </div>
                </div>
                <div className="browse__images-container">
                     <div className="browse__content-images" 
                        style={{
                            transform: `translateX(-${calcTranslation(main, 12, 1)}vw)`
                        }}
                     >
                        {renderItems()}
                    </div>
                  { main > 0 &&  <button  onClick={() => setMain(0)} className="browse__image-reset">
                        <BsCaretLeft size="35"/>
                    </button>}
                </div>
        </div>
    );
}

export default Browse;
